import type {PartyRole, PayoutInstructionStatus} from '@sollapay/enums';
import type {CreatedAtFilter} from '@sollapay/ui/components';

export type {CreatedAtFilter};

export const CREATED_AT_FILTER_VALUES: CreatedAtFilter[] = ['all', 'this_week', '7d', '30d', '90d'];

export interface PayoutsFilterState {
  datePreset: CreatedAtFilter;
  amountMin?: number;
  amountMax?: number;
  statuses: PayoutInstructionStatus[];
  roles: PartyRole[];
}

export const DEFAULT_PAYOUTS_FILTER_STATE: PayoutsFilterState = {
  datePreset: 'all',
  statuses: [],
  roles: []
};
